import React, { useEffect, useState, useContext, useRef } from 'react'
import SearchComp from './SearchComp'
import SavedSearch from './SavedSearch'
import FilterPanel from '@/product/components/species/dynamic/common/FilterPanel/Filter'
import SortbyCom from './SortbyComp'
import { Button, ListItem, Popover, makeStyles } from '@material-ui/core'
import { Drawer } from '@material-ui/core'
import { useFormik } from 'formik'
import Filters from '../Dashboard/MyAuctions/SortbyComp'
import AuthContext from '@/product/context/auth/authContext'
import Commoncomp from '../Dashboard/MyAuctions/SortbyComp'
import { handleRedirectInternal } from '@/custom/common/components'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import SEO from '@/utils/SEO'
import { initialSearchFunction } from '../../product/components/species/dynamic/common/FieldFunction'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import { ShowChart } from '@material-ui/icons'
import Banner from '../../custom/components/molecules/Banner'
import ReviewComponent from '@/product/components/species/components/general/ReviewComponent'
import { NavLink } from 'react-router-dom/cjs/react-router-dom'
import Loaders from '@/custom/components/molecules/Loaders'
import CustomCommonContext from '@/custom/context/common/commonContext'
import InvoiceContext from '@/product/context/invoice/invoiceContext'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import ProductContext from '@/product/context/product/productContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import * as Yup from 'yup'
import CommonContext from '@/product/context/common/commonContext'
import { mapData } from '@/product/common/components'

const Search = (props) => {
    const { t } = useTranslation()

    const authContext = useContext(AuthContext)
    const dynamicContext = useContext(DynamicContext)
    const customCommonContext = useContext(CustomCommonContext)
    const productContext = useContext(ProductContext)
    const commonContext = useContext(CommonContext)
    const {
        responseStatus: responseStatusProduct,
        clearResponse: clearResponseProduct,
        search_allproducts,
        getAllSearchProducts,
        responseStatus,
        addSavedSearch,
        getAllActiveSorts,
        active_sorts,
        setSavedSearchModel,
        savedSearchModel,
        getSavedSearch,
        saved_searches,
    } = productContext
    const { getAllDynamicArray, dynamicValue } = dynamicContext
    const { searchValue, setSearchValue } = commonContext
    const { allCategory, allCondition, allLocations, alldata_all_dropdown } = customCommonContext
    const invoiceContext = useContext(InvoiceContext)
    const { search_alluserinvoices, getAllSellerUserInvoices } = invoiceContext

    const [dynamicArray, setDynamicArray] = useState([])
    const [initialValues, setInitialValues] = useState({})
    const [initialEmptyValues, setInitialEmptyValues] = useState({})
    const [arrayValue, setArrayValue] = useState([])
    const [reload, setReload] = useState(false)
    const { user, isAuthenticated } = authContext
    const [show, setShow] = useState(false)
    const [initialUpdate, setInitialUpdate] = useState(false)
    const [update, setUpdate] = useState({})
    const [searchUpdate, setSearchUpdate] = useState(false)
    const [anchorEl, setAnchorEl] = useState(false)
    const [isActive] = useState('active')
    const [searchText, setSearchText] = useState('')
    const [companyHeadCount, setCompanyHeadCount] = useState([])
    const [companyCategory, setCompanyCategory] = useState([])
    const [senioritys, setSenioritys] = useState([])
    const [showValues, setShowValues] = useState(false)
    const [assetClassFocus, setAssetClassFocus] = useState([])
    const [jobFunction, setJobFunction] = useState([])

    const history = useHistory()
    var Path = history.location.search

    // popover start

    const filterHandleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleConfirmFilter = (noAnchor = true) => {
        if (formikSelection?.values?.filters) {
            let filterVal = formikSelection.values.filters
            let addVal = {
                id: 0,
                company_head_count: filterVal.company_head_count.value || [],
                company_category: filterVal.company_category.value || [],
                seniority: filterVal.seniority.value || [],
                search_text: filterVal.search_text.value || searchText,
                asset_class_focus: filterVal.asset_class_focus.value || [],
                job_function: filterVal.job_function.value || [],
            }
            if (saved_searches.records.length) {
                addVal.id = saved_searches.records[0].id
            }
            if (!user.admin || user.both_access) addSavedSearch(addVal, true)
        }
        if (noAnchor) setAnchorEl(!anchorEl)
    }

    const filterHandleClose = () => {
        setAnchorEl(!anchorEl)
    }
    // popover  end

    const open = Boolean(anchorEl)
    const id = open ? 'simple-popover' : undefined

    // const searchText = [
    //     {
    //         label: 'Search',
    //         name: 'Search',
    //         type: 'search',
    //         placeholder: `Search`,
    //         class: '',
    //         size: 'small',
    //         autoFocus: false,
    //     },
    // ]

    const [companyCat, setCompanyCat] = useState({
        filter: true,
        item: [],
        name: 'company_category',
        field: 'cu.company_category',
        search_type: 'checkbox',
        title: 'Current Company Category',
        filter_order: 2,
        type: 'select',
        label: 'Current Company Category',
        static: 1,
        is_default: 1,
    })

    const [companyHead, setCompanyHead] = useState({
        filter: true,
        item: [],
        name: 'company_head_count',
        field: 'cu.company_head_count',
        search_type: 'checkbox',
        title: 'Current Company Head Count',
        filter_order: 2,
        type: 'select',
        label: 'Current Company Head Count',
        static: 1,
        is_default: 1,
    })

    const [seniority, setSeniority] = useState({
        filter: true,
        item: [],
        name: 'seniority',
        field: 'cu.seniority',
        search_type: 'checkbox',
        title: 'Seniority',
        filter_order: 3,
        type: 'select',
        label: 'Seniority',
        static: 1,
        is_default: 1,
    })

    const [asset, setAsset] = useState({
        filter: true,
        item: [],
        name: 'asset_class_focus',
        field: 'cu.asset_class_focus',
        search_type: 'checkbox',
        title: 'Asset Class Focus',
        filter_order: 4,
        type: 'select',
        label: 'Asset Class Focus',
        static: 1,
        is_default: 1,
    })

    const [job, setJob] = useState({
        filter: true,
        item: [],
        name: 'job_function',
        field: 'cu.job_function',
        search_type: 'checkbox',
        title: 'Job Function',
        filter_order: 5,
        type: 'select',
        label: 'Job Function',
        static: 1,
        is_default: 1,
    })

    const [auctionView, setAuctionView] = useState('Grid')

    const pageOptions = [
        {
            value: '12',
            show: '12 per page',
        },
        {
            value: '24',
            show: '24 per page',
        },
        {
            value: '36',
            show: '36 per page',
        },
    ]

    const sortShow = [
        {
            value: 'p.id, desc',
            show: 'None',
        },
        {
            value: `CASE WHEN p.wprice > 0 THEN 0 ELSE 1 END ASC, p.wprice asc`,
            show: 'Low to High',
        },
        {
            value: `CASE WHEN p.wprice > 0 THEN 0 ELSE 1 END ASC, p.wprice desc`,
            show: 'High to Low',
        },
        {
            value: 'p.date_closed, asc',
            show: 'Time remaining',
        },
        {
            value: 1,
            show: 'Ending today',
        },
    ]

    // const formikSearch = useFormik({
    //     initialValues: {
    //         limit: 12,
    //         page: 1,
    //         orderby: 'p.id, desc',
    //         order: '',
    //         auctionView: 'Grid',
    //         filters: {
    //             categoryTypeId: {
    //                 value: [],
    //                 type: 'array',
    //                 field: 'it.categoryTypeId',
    //             },
    //             searchbar: {
    //                 value: '',
    //                 type: 'like',
    //                 field: 'p.title,p.desc_proc',
    //             },
    //             subCategoryTypeId: {
    //                 value: [],
    //                 type: 'array',
    //                 field: 'it.subCategoryTypeId',
    //             },
    //             condition: {
    //                 value: [],
    //                 type: 'array',
    //                 field: 'it.conditionTypeId',
    //             },
    //             location: {
    //                 value: [],
    //                 type: 'array',
    //                 field: 'p.location_id',
    //             },
    //             price: {
    //                 value: 0,
    //                 type: 'greaterequal',
    //                 field: 'p.wprice',
    //             },
    //             auctionid: {
    //                 value: [],
    //                 type: 'array',
    //                 field: 'p.auction',
    //             },
    //             buynowid: {
    //                 value: [],
    //                 type: 'array',
    //                 field: 'p.buynow',
    //             },
    //             min_price: {
    //                 value: 0,
    //                 type: 'greaterequal',
    //                 field: 'p.wprice',
    //             },
    //             max_price: {
    //                 value: 0,
    //                 type: 'smallerequal',
    //                 field: 'p.wprice',
    //             },
    //         },
    //     },
    //     enableReinitialize: true,
    // })

    const formikSearch = useFormik({
        initialValues: {
            limit: 12,
            page: 1,
            orderby: 'p.id, desc',
            order: '',
            auctionView: 'Grid',
            filters: initialValues,
            having: {
                future_active: {
                    value: 0,
                    type: 'in',
                    field: 'future_active',
                },
            },
            market_status: 'open',
        },
        enableReinitialize: true,
    })

    const updateView = (data) => {
        setAuctionView(data)
    }

    const searchinitialValues = {
        searchValue: '',
    }

    const clearSearchFilter = () => {
        let filter = {
            ...initialEmptyValues,
            searchbar: {
                value: '',
                type: 'like',
                field: 'p.title,p.desc_proc,u.companyname,cu.job_title',
            },
        }
        formikSearch.values = {
            ...formikSearch.values,
            limit: 12,
            page: 1,
            orderby: 'p.id, desc',
            order: '',
            filters: filter,
            having: {
                future_active: {
                    value: 0,
                    type: 'in',
                    field: 'future_active',
                },
            },
        }
        setSearchText('')
        formikSearch.handleReset()
        setUpdate(formikSearch)
        console.log(formikSearch.values, 'filterrr')
        setShow(true)
    }

    // const clearSearchFilter = () => {
    //     formikSearch.values = {
    //         ...formikSearch.values,
    //         limit: 12,
    //         page: 1,
    //         orderby: 'p.id, desc',
    //         order: '',
    //         filters: {
    //             categoryTypeId: {
    //                 ...formikSearch.values.filters.categoryTypeId,
    //                 value: [],
    //             },
    //             subCategory: {
    //                 ...formikSearch.values.filters.subCategory,
    //                 value: [],
    //             },
    //             condition: {
    //                 ...formikSearch.values.filters.condition,
    //                 value: [],
    //             },
    //             location: {
    //                 ...formikSearch.values.filters.location,
    //                 value: [],
    //             },
    //             price: {
    //                 ...formikSearch.values.filters.price,
    //                 value: 0,
    //             },
    //             searchbar: {
    //                 ...formikSearch.values.filters.searchbar,
    //                 value: '',
    //             },
    //             auctionid: {
    //                 ...formikSearch.values.filters.auctionid,
    //                 value: [],
    //             },
    //             buynowid: {
    //                 ...formikSearch.values.filters.buynowid,
    //                 value: [],
    //             },
    //             min_price: {
    //                 ...formikSearch.values.filters.min_price,
    //                 value: 0,
    //             },
    //             max_price: {
    //                 ...formikSearch.values.filters.max_price,
    //                 value: 0,
    //             },
    //         },
    //     }
    //     formikSearch.handleReset()
    //     setUpdate(formikSearch)
    //     console.log(formikSearch.values, 'filterrr')
    //     setShow(true)
    // }

    useEffect(() => {
        if (alldata_all_dropdown.length) {
            let mapping = [...alldata_all_dropdown]
            let companyHeadCount = []
            let companyCategory = []
            let assetClassFocus = []
            let seniority = []
            let jobFunction = []
            let allBody = []
            mapping.map((lot, index) => {
                if (lot.variable == 'company_head_count') {
                    companyHeadCount.push({ value: lot.id.toString(), show: lot.description })
                } else if (lot.variable == 'company_category') {
                    companyCategory.push({ value: lot.id.toString(), show: lot.description })
                } else if (lot.variable == 'seniority') {
                    seniority.push({ value: lot.id.toString(), show: lot.description })
                } else if (lot.variable == 'asset_class_focus') {
                    assetClassFocus.push({ value: lot.id.toString(), show: lot.description })
                } else if (lot.variable == 'job_function') {
                    jobFunction.push({ value: lot.id.toString(), show: lot.description })
                } else if (lot.variable == 'body_type') {
                    allBody.push({ value: lot.id.toString(), show: lot.description })
                }
            })
            setCompanyHeadCount(companyHeadCount)
            setCompanyCategory(companyCategory)
            setSenioritys(seniority)
            setAssetClassFocus(assetClassFocus)
            setJobFunction(jobFunction)
            // setBodyType(allBody)
        }
    }, [alldata_all_dropdown])

    const resetForm = () => {
        formikSelection.values.id = ''
        formikSelection.values.search_text = ''
        formikSelection.values.company_head_count = []
        formikSelection.values.company_category = []
        formikSelection.values.seniority = []
        formikSelection.values.asset_class_focus = []
        formikSelection.values.doors = ''
        formikSelection.values.job_function = []
        formikSelection.handleReset()
    }

    const validationArray = Yup.object({
        search_text: Yup.string().required(t('Title is required feild')),
    })

    const formikSelection = useFormik({
        initialValues: {
            id: 0,
            // company_head_count: [],
            // company_category: [],
            // seniority: [],
            // search_text: '',
            // asset_class_focus: [],
            // job_function: [],
            filters: {
                company_head_count: {
                    value: [],
                },
                company_category: {
                    value: [],
                },
                seniority: {
                    value: [],
                },
                search_text: '',
                asset_class_focus: {
                    value: [],
                },
                job_function: {
                    value: [],
                },
            },
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            addSavedSearch(values, true)
            resetForm()
            setEditDialog(false)
        },
    })

    const changeEditDialogStatus = () => {
        setSavedSearchModel(false)
    }
    const closeFunction = () => {
        setSavedSearchModel(false)
    }

    const searchBody = {
        formik: formikSelection,
        data: [
            {
                label: t('title'),
                type: 'text',
                placeholder: t('Enter the title'),
                class: 'col-12',
                name: 'search_text',
            },
            {
                label: t('Select Company Head Count'),
                type: 'multiselect',
                placeholder: t('Select Company Head Count'),
                class: 'col-12',
                options: companyHeadCount,
                name: 'company_head_count',
                filter: true,
            },
            {
                label: t('Select Company Category'),
                type: 'multiselect',
                placeholder: t('Select Company Category'),
                class: 'col-12',
                options: companyCategory,
                name: 'company_category',
                filter: true,
            },
            {
                label: t('Select Company Category'),
                type: 'multiselect',
                placeholder: t('Select Company Category'),
                class: 'col-12',
                options: senioritys,
                name: 'seniority',
                filter: true,
            },
            {
                label: t('Select Asset Class Focus'),
                type: 'multiselect',
                placeholder: t('Select Asset Class Focus'),
                class: 'col-12',
                options: assetClassFocus,
                name: 'asset_class_focus',
                filter: true,
            },
            {
                label: t('Select Asset Class Focus'),
                type: 'multiselect',
                placeholder: t('Select Asset Class Focus'),
                class: 'col-12',
                options: jobFunction,
                name: 'job_function',
                filter: true,
            },
        ],
    }

    useEffect(() => {
        getSavedSearch({ page: 1, limit: 1 })
    }, [])

    useEffect(() => {
        if (formikSearch.values?.filters?.asset_class_focus) {
            setShowValues(true)
        } else {
            setShowValues(false)
        }
    }, [formikSearch.values])

    useEffect(() => {
        if (responseStatusProduct) {
            console.log('responseStatusProduct', responseStatusProduct)
            if (responseStatusProduct.from === 'saved_search_msg') {
                if (responseStatusProduct.status === 'success') {
                    closeFunction()
                    // if (!user) setSavedSearchPopup(true)
                }
            }
        }
    }, [responseStatusProduct])

    useEffect(() => {
        if (formikSearch.values?.filters?.searchbar?.value || searchText) {
            if (searchText) {
                formikSelection.setFieldValue('search_text', searchText)
            } else {
                formikSelection.setFieldValue(
                    'search_text',
                    formikSearch.values.filters.searchbar.value,
                )
            }
        }
        if (formikSearch.values?.filters) {
            let searchFilter = formikSearch.values.filters
            Object.keys(searchFilter).forEach((key) => {
                if (key != 'searchbar') {
                    let value = searchFilter[`${key}`].value
                    formikSelection.setFieldValue(`filters.${key}.value`, value)
                }
            })
        }
    }, [formikSearch.values, searchText])

    useEffect(() => {
        if (alldata_all_dropdown?.length) {
            let head = []
            let category = []
            let seniorityData = []
            let assetData = []
            let jobData = []

            alldata_all_dropdown.map((item) => {
                if (item.variable === 'company_head_count') {
                    let valueChanged = {}
                    valueChanged.description = item.description
                    valueChanged.id = item.id
                    head.push(valueChanged)
                }
                if (item.variable === 'company_category') {
                    let valueChanged = {}
                    valueChanged.description = item.description
                    valueChanged.id = item.id
                    category.push(valueChanged)
                }
                if (item.variable === 'seniority') {
                    let valueChanged = {}
                    valueChanged.description = item.description
                    valueChanged.id = item.id
                    seniorityData.push(valueChanged)
                }
                if (item.variable === 'asset_class_focus') {
                    let valueChanged = {}
                    valueChanged.description = item.description
                    valueChanged.id = item.id
                    assetData.push(valueChanged)
                }
                if (item.variable === 'job_function') {
                    let valueChanged = {}
                    valueChanged.description = item.description
                    valueChanged.id = item.id
                    jobData.push(valueChanged)
                }
            })
            setCompanyHead({
                ...companyHead,
                item: head || [],
            })
            setCompanyCat({ ...companyCat, item: category || [] })
            setSeniority({
                ...seniority,
                item: seniorityData || [],
            })
            setAsset({
                ...asset,
                item: assetData || [],
            })
            setJob({
                ...job,
                item: jobData || [],
            })
        }
    }, [alldata_all_dropdown])

    useEffect(() => {
        getAllDynamicArray(
            {
                page: 1,
                limit: 20,
                order: '',
                orderby: '',
                table: 'dynamic_fields',
                filters: {
                    fields: {
                        value: '1',
                        type: 'in',
                        field: 'df.view_page',
                    },
                    search: {
                        value: '1',
                        type: 'in',
                        field: 'df.search',
                    },
                    active: {
                        value: '1',
                        type: 'in',
                        field: 'df.active',
                    },
                },
            },
            'searchDynamic',
        )
    }, [])

    useEffect(() => {
        if (dynamicValue.from === 'searchDynamic') {
            if (dynamicValue.records.length) {
                setDynamicArray(dynamicValue.records)
            }
        }
    }, [dynamicValue])

    useEffect(() => {
        if (user?.membership) {
            changeAuctionType('active', 'search?type=active')
        }
    }, [user])

    useEffect(() => {
        if (dynamicArray.length) {
            let arrayAdded = dynamicArray
            arrayAdded = arrayAdded.filter((e) => e.name != 'buynow')
            if (companyCat) {
                arrayAdded = [...arrayAdded, companyCat]
            }
            if (companyHead) {
                arrayAdded = [...arrayAdded, companyHead]
            }
            if (asset) {
                arrayAdded = [...arrayAdded, asset]
            }
            if (job) {
                arrayAdded = [...arrayAdded, job]
            }
            if (seniority) {
                arrayAdded = [...arrayAdded, seniority]
            }
            const additional = {
                filter: true,
                item: [
                    { id: 1, description: 'Buynow', show: 'buynow' },
                    { id: 1, description: 'Auction', show: 'auction' },
                ],
                name: 'retrieval',
                search_type: 'checkbox',
                title: 'Additional Filter Options',
                type: 'select',
                removeFilter: true,
                label: t('Additional filter'),
                static: 1,
                is_default: 1,
                filter_order: 14,
            }
            arrayAdded = [...arrayAdded, additional]
            let sortedArray = arrayAdded.sort((a, b) => (a.filter_order > b.filter_order ? 1 : -1))
            setArrayValue(sortedArray)
        }
    }, [dynamicArray, jobFunction])

    useEffect(() => {
        setInitialValues({})
        setInitialEmptyValues({})
        setInitialUpdate(false)

        if (arrayValue.length) {
            let mapValueArray = arrayValue
            let custom = {
                searchbar: {
                    value: '',
                    type: 'like',
                    field: 'p.title,p.desc_proc,u.companyname,cu.job_title',
                },
                buynow: {
                    field: 'p.buynow',
                    type: 'array',
                    value: '',
                },
                auction: {
                    field: 'p.auction',
                    type: 'array',
                    value: '',
                },
            }

            let show = initialSearchFunction(mapValueArray)
            setInitialValues({ ...custom, ...show })
            setInitialEmptyValues({ ...custom, ...show })
            setTimeout(() => {
                if (Object.keys(show).length) {
                    setInitialUpdate(true)
                    setReload(!reload)
                }
            }, 1000)
        } else {
            let custom = {
                searchbar: {
                    value: '',
                    type: 'like',
                    field: 'p.title,p.desc_proc',
                },
            }
            setInitialValues(custom)
            setInitialEmptyValues(custom)
            setTimeout(() => {
                if (Object.keys(custom).length) {
                    setInitialUpdate(true)
                    setReload(!reload)
                }
            }, 1000)
        }
    }, [arrayValue])

    useEffect(() => {
        if (initialValues && saved_searches) {
            let arr = [
                'company_head_count',
                'company_category',
                'seniority',
                'asset_class_focus',
                'job_function',
                'search_text',
            ]
            if (saved_searches.records.length) {
                let searchFilter = saved_searches.records[0]
                let temp = {}
                Object.keys(searchFilter).forEach((key) => {
                    if (arr.includes(key)) {
                        if (key != 'search_text') {
                            let value = { value: searchFilter[`${key}`], type: 'number' }
                            temp[key] = value
                        } else {
                            let value = { value: searchFilter[`${key}`] }
                            temp['searchbar'] = value
                        }
                    }
                })
                setSearchValue({ filters: temp })
            }
        }
    }, [saved_searches, initialValues])

    useEffect(() => {
        if (isAuthenticated) {
            if (user.admin) {
                getAllSellerUserInvoices({
                    limit: 10,
                    page: 1,
                    // orderby: 1,
                    checkout: 1,
                    admin: 1,
                    filters: {
                        active: {
                            value: '2',
                            type: 'notin',
                            field: 'b.active',
                        },
                        action: {
                            value: 'all',
                            type: 'in',
                            field: 'p.market_Status',
                        },
                        project_id: {
                            value: '',
                            type: 'in',
                            field: 'b.project_id',
                        },
                    },
                })
            }
        }
    }, [isAuthenticated, user])

    useEffect(() => {
        if (search_alluserinvoices && search_alluserinvoices.fetched) {
            if (user) {
                if (!search_alluserinvoices.records.length) {
                    if (user.admin && !user.both_access)
                        handleRedirectInternal(history, 'seller/lots/open')
                }
            }
        }
    }, [search_alluserinvoices, user])

    const reviewData = [
        {
            enable: 1,
            apiKey: '63f46395ae8edf3f88bf4a42',
        },
    ]
    const queryString = window.location.search

    const urlParams = new URLSearchParams(queryString)

    // useEffect(() => {
    //     if (urlParams.get('type') === 'upcoming') {
    //         formikSearch?.setFieldValue('having', {
    //             ...formikSearch.values.having,
    //             future_active: {
    //                 ...formikSearch.values.having.future_active,
    //                 value: 1,
    //             },
    //         })
    //         formikSearch?.setFieldValue('market_status', 'open')
    //     } else if (urlParams.get('type') === 'active') {
    //         formikSearch?.setFieldValue('market_status', 'open')
    //     } else if (urlParams.get('type') === 'past') {
    //         formikSearch?.setFieldValue('market_status', ['closed', 'sold', 'unsold'])
    //     }
    // }, [urlParams.get('type')])

    const changeAuctionType = (type, url) => {
        handleRedirectInternal(history, url)
        if (type == 'active') {
            formikSearch?.setFieldValue('market_status', 'open')
            formikSearch.values.having.future_active.value = 0
        } else if (type == 'past') {
            console.log(formikSearch, 'f===>')
            formikSearch?.setFieldValue('market_status', ['closed', 'sold', 'unsold'])
            formikSearch.values.having.future_active.value = 0
        } else if (type == 'upcoming') {
            formikSearch?.setFieldValue('having', {
                ...formikSearch.values.having,
                future_active: {
                    ...formikSearch.values.having.future_active,
                    value: 1,
                },
            })
            formikSearch?.setFieldValue('market_status', 'open')
        }
        setSearchUpdate(!searchUpdate)
    }

    const handleSearchTextChange = () => {
        formikSearch.setFieldValue(`filters.searchbar.value`, searchText)
        handleConfirmFilter(false)
    }

    const handleSearchKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearchTextChange()
        }
    }

    return (
        <>
            {initialUpdate ? (
                <>
                    {/* <div className="home">
                        <section className="heroBanner">
                            <Banner />
                        </section>
                    </div> */}
                    <SEO title="Search" url={window.location.href} />
                    <div className="customContainer">
                        <div className="search d-flex">
                            {/* <div className="searchLt">
                            <div className="deskFilter">
                                <FilterPanel
                                    formik={formikSearch}
                                    clearSearch={clearSearchFilter}
                                    from={1}
                                    show={show}
                                    arrayValue={arrayValue}
                                    update={update}
                                />
                            </div>
                        </div> */}
                            <div className="searchRt">
                                {/* <div>BreadCrumbs</div> */}
                                <SavedSearch
                                    formikSearch={formikSearch}
                                    isvisible={true}
                                    update={searchUpdate}
                                    showValues={showValues}
                                    setEditDialog={setSavedSearchModel}
                                />
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <div className="form-inline headerSearchForm">
                                        <input
                                            className="form-control"
                                            type="search"
                                            placeholder="search..."
                                            aria-label="Search"
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                            onKeyDown={handleSearchKeyDown}
                                        />
                                        <Button
                                            id="header_searchButton"
                                            className="btn"
                                            onClick={handleSearchTextChange}
                                        >
                                            <span className="material-icons">search</span>
                                        </Button>
                                    </div>
                                    <Commoncomp
                                        path={false}
                                        viewSwitch={false}
                                        resultPerPage={true}
                                        sortBy={true}
                                        formikSearch={formikSearch}
                                        setAuctionView={updateView}
                                        sortShow={sortShow}
                                        pageOptions={pageOptions}
                                    />
                                </div>
                                <div className="FilterDocker mb-4">
                                    <div className="productSts">
                                        <ListItem
                                            button
                                            className={
                                                Path == '?type=active' ||
                                                history.location.pathname == '/'
                                                    ? 'active'
                                                    : null
                                            }
                                            onClick={() =>
                                                changeAuctionType('active', 'search?type=active')
                                            }
                                        >
                                            Active
                                        </ListItem>
                                        <ListItem
                                            button
                                            className={Path == '?type=upcoming' ? 'active' : null}
                                            onClick={() =>
                                                changeAuctionType(
                                                    'upcoming',
                                                    'search?type=upcoming',
                                                )
                                            }
                                        >
                                            Upcoming
                                        </ListItem>
                                        <ListItem
                                            button
                                            className={Path == '?type=past' ? 'active' : null}
                                            onClick={() =>
                                                changeAuctionType('past', 'search?type=past')
                                            }
                                        >
                                            Past
                                        </ListItem>
                                    </div>
                                    <div className="filterButton">
                                        <Button onClick={filterHandleClick}>
                                            Filter
                                            <span className="material-icons-outlined ml-2">
                                                tune
                                            </span>
                                        </Button>
                                    </div>
                                </div>
                                <SearchComp
                                    formikSearch={formikSearch}
                                    clearSearchFilter={clearSearchFilter}
                                    auctionView={auctionView}
                                    pagination={true}
                                />
                                {/* <ReviewComponent data={reviewData} /> */}
                            </div>
                        </div>
                    </div>
                    <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={filterHandleClose}
                        className="filterCategory"
                        getContentAnchorEl={null}
                        PaperProps={{
                            style: {
                                width: '1300px', // Set the desired width here
                            },
                        }}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        component="FilterPopOver"
                    >
                        <div className="homeFilter">
                            <FilterPanel
                                clearSearch={clearSearchFilter}
                                arrayValue={arrayValue}
                                formik={formikSearch}
                                update={update}
                                show={show}
                                from={1}
                            />
                            <PrimaryButton
                                label="Confirm"
                                onClick={handleConfirmFilter}
                            ></PrimaryButton>
                        </div>
                    </Popover>
                </>
            ) : (
                <div className="basicLoader">
                    <Loaders name="home" isLoading={true} />
                </div>
            )}
            <CustomDialog
                title={t('add_saved_search')}
                open={savedSearchModel}
                function={changeEditDialogStatus}
                disableBackdropClick
                handleClose={closeFunction}
            >
                <div className="row">{mapData(searchBody, false, false, t)}</div>
                {/* <p className="forPass d-block text-center">
                    {t('Ya tienes una cuenta')}?
                    <Button id="login_signup" onClick={() => setLoginModal(true)} className="aPass">
                        {t('Identificarse')}
                    </Button>
                </p> */}
                <div className="actionWrapper">
                    <Button id="no_cancel" onClick={() => closeFunction()}>
                        {t('cancel')}
                    </Button>
                    <PrimaryButton
                        id="category_submit"
                        type="button"
                        onClick={() => formikSelection.handleSubmit()}
                        label="ACTIVAR"
                    />
                </div>
            </CustomDialog>
        </>
    )
}
export default Search
